"use client";


import dynamic from "next/dynamic";

export const LazyRichText = dynamic(() => import("./RichText"));
